var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "monitor-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.45245 20.8827H16.238M12.3452 16.99V20.8827M7.28462 16.99H17.4058C19.041 16.99 19.8585 16.99 20.4831 16.6717C21.0324 16.3918 21.4791 15.9452 21.759 15.3958C22.0772 14.7713 22.0772 13.9537 22.0772 12.3186V8.03657C22.0772 6.40145 22.0772 5.58389 21.759 4.95936C21.4791 4.41 21.0324 3.96336 20.4831 3.68345C19.8585 3.36523 19.041 3.36523 17.4058 3.36523H7.28462C5.6495 3.36523 4.83194 3.36523 4.2074 3.68345C3.65805 3.96336 3.21141 4.41 2.9315 4.95936C2.61328 5.58389 2.61328 6.40145 2.61328 8.03657V12.3186C2.61328 13.9537 2.61328 14.7713 2.9315 15.3958C3.21141 15.9452 3.65805 16.3918 4.2074 16.6717C4.83194 16.99 5.6495 16.99 7.28462 16.99Z",
    stroke: "#38cb89",
    strokeWidth: 1.94639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.54cde4c57cb74b9d6163b4edae97a29f.svg";
export { ForwardRef as ReactComponent };